namespace advisorop.components.servicer {

    class WorkflowMonitorFullscrController {

        $router;
        workflowMasterId;

        static $inject = ["generalService", "identityService", "servicerService", "workflowApi"];
        constructor() {
        }

        $routerOnActivate(next, previous) {
            this.workflowMasterId = <number>next.params.workflowMasterId;
        }
    }

    class WorkflowMonitorFullscr implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public $routeConfig: any;

        constructor() {
            this.bindings = {
                "$router": "<",
            };
            this.controller = WorkflowMonitorFullscrController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/servicer-module/components/workflow-monitor-fullscr.html';
        }
    }
    angular.module(Constants.APP).component("workflowMonitorFullscr", new WorkflowMonitorFullscr());
}